import moment from 'moment';

const csvTemplate = {
  rows: [
    ['NAME', 'RADIUS', 'ADDRESS', 'LAT', 'LON'],
    ['MediaJel', '50', '1601 N Main St Suite', '14.7980323', '121.0449656'],
  ],
  templateName: 'MJ_GeoTarget_Template',
};

const kpiDefaultOptions = [
  {
    key: 'transactions',
    kpi: 'Transactions',
  },
  {
    key: 'signups',
    kpi: 'Sign-Ups',
  },
  {
    key: 'sessions',
    kpi: 'Sessions',
  },
];

// Utility to normalize dates to start/end of day in UTC
const normalizeStartDate = (date) => {
  if (!date) return moment().utc().startOf('day');
  return moment(date).utc().startOf('day');
};

const normalizeEndDate = (date) => {
  if (!date) return moment().add(2, 'days').utc().endOf('day');
  return moment(date).utc().endOf('day');
};

const getLineItemsDefaultValue = (startDate = null, endDate = null) => [
  {
    name: 'Line Item 1',
    startDate: normalizeStartDate(startDate),
    endDate: normalizeEndDate(endDate),
    budgetTotal: 0,
    budgetPercentage: 100,
    cpm: 7,
    regionGroups: [],
    targetingGroups: [],
    targetingType: null,
    targetingRegions: [],
    targetingLocations: [],
    targetingCountries: null,
    audienceType: null,
    firstPartyDataAudiences: [],
    adGroup: null,
  },
];

// Default campaign structure for multi-campaign support
const getCampaignDefaultValue = (startDate = null, endDate = null) => ({
  name: '',
  type: 1, // Default to Display campaign
  budget: 0,
  startDate: normalizeStartDate(startDate), // Normalized to start of day UTC
  endDate: normalizeEndDate(endDate),       // Normalized to end of day UTC
  lineItems: getLineItemsDefaultValue(startDate, endDate),
});

// Default campaigns array (backwards compatible - wraps line items in single campaign)
const getCampaignsDefaultValue = (startDate = null, endDate = null) => [
  {
    name: '',
    type: 1, // Default to Display campaign
    budget: 0,
    startDate: normalizeStartDate(startDate), // Normalized to start of day UTC
    endDate: normalizeEndDate(endDate),       // Normalized to end of day UTC
    lineItems: getLineItemsDefaultValue(startDate, endDate),
  },
];

// Legacy static values for backward compatibility
const lineItemsDefaultValue = getLineItemsDefaultValue();
const campaignDefaultValue = getCampaignDefaultValue();
const campaignsDefaultValue = getCampaignsDefaultValue();

export const CampaignConfig = {
  csvTemplate,
  kpiDefaultOptions,
  lineItemsDefaultValue,
  campaignDefaultValue,
  campaignsDefaultValue,
  // Functions for date inheritance
  getLineItemsDefaultValue,
  getCampaignDefaultValue,
  getCampaignsDefaultValue,
};
